import { connect } from 'react-redux';
import SnacksAsideMobileComponent from './SnacksAsideMobileComponent.component';
import concessionsModule from 'app/store/concessions';

const { setConcessionOnServer, setConcessionComboOnServer, requestConcessionOnServer, requestConcessionRemove, requestConcessionComboOnServer } = concessionsModule.actions;

const mapDispatchToProps = {
  requestConcessionOnServer: requestConcessionOnServer,
  requestConcessionComboOnServer: requestConcessionComboOnServer,
  removeConcession: requestConcessionRemove,
  setConcessionOnServer,
  setConcessionComboOnServer
};
const mapStateToProps = ({ }) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(SnacksAsideMobileComponent);